export default __webpack_public_path__ + "assets/front/scss/user-profile.c5fbeee33f3d6895ce0cbd8d04e528ac.css";